import React from 'react'

import './Stepper.style.css'

type StepperProps = {
  steps: string[]
  currentStep: number
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
  const getStepClass = (step: number): string => {
    let cls = 'step'
    if (currentStep === step) {
      cls += ' step-active'
    } else if (currentStep > step) {
      cls += ' step-done'
    } else {
      cls += ' step-inactive'
    }
    return cls
  }

  return (
    <div className="steps-container">
      {steps.map((label, index) => (
        <div className={getStepClass(index)} key={index}>
          <div>
            <div className="circle">
              {currentStep > index ? (
                <i className="ti ti-check"></i>
              ) : (
                index + 1
              )}
            </div>
          </div>
          <div className="label">{label}</div>
          {index < steps.length - 1 && <div className="line"></div>}
        </div>
      ))}
    </div>
  )
}

export default Stepper
